module.exports = __webpack_public_path__ + "img/141.abf8708c.jpg";